import Avatar from '@atlaskit/avatar';
import { LoadingButton } from '@atlaskit/button';
import Button from '@atlaskit/button/standard-button';
import { Ratings } from '@atlassian/amkt-common';
import { deleteReview } from '@atlassian/mpac-api-client';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import React, { useEffect, useState } from 'react';
import { useAsync } from 'react-async';
import { lazy, LazySuspense } from 'react-loosely-lazy';
import { TEST_ID } from "../../../../../constants";
import { FlagReview } from "./FlagReview/FlagReview";
import { ActionContainer, Author, AvatarContainer, ContentContainer, ReviewContent, ReviewHeading, UserActions, UserReviewContainer } from "./UserReview.styles";
import { VendorResponse } from "./VendorResponse/VendorResponse";
import { VoteReview } from "./VoteReview";
const LazyVendorResponseEditor = lazy(() => import( /* webpackPrefetch: true, webpackChunkName: "chunk-Vendor-response-editor" */"./VendorResponseEditor"));
/* eslint-disable complexity */
// eslint-disable-next-line max-lines-per-function
export const UserReview = ({
  index,
  author,
  ratings,
  date,
  review,
  helpfulVotes,
  totalVotes,
  voteUpEndpoint,
  voteDownEndpoint,
  selfEndpoint,
  user,
  flagEndpoint,
  mpacBaseUrl,
  loginHref,
  vendorDetails,
  filterOutDeletedReview,
  filterOutDeletedVendorResponse,
  id
}) => {
  const {
    isPending: isDeletingInProgress,
    isFulfilled: isDeleteSuccessful,
    isRejected: isDeleteRejected,
    error: deleteReviewError,
    run: runDelete
  } = useAsync({
    deferFn: deleteReview
  });
  const [showEditor, setShowEditor] = useState(false);
  const [postedVendorResponse, setpostedVendorResponse] = useState('');
  const {
    picture,
    name,
    isReviewAuthor,
    profileUrl
  } = author;
  useEffect(() => {
    if (isDeleteRejected) log.error('ReviewsTab', 'failed to delete a Review', {
        deleteReviewError
      });
  }, [isDeleteRejected]);
  const permissions = usePartnerPermissions();
  const handlePostedVendorResponse = value => {
    setpostedVendorResponse(value);
    setShowEditor(false);
  };
  const handleEditVendorResponse = () => {
    setShowEditor(true);
  };
  useEffect(() => {
    if (isDeleteSuccessful && selfEndpoint) {
      filterOutDeletedReview(selfEndpoint);
    }
  }, [isDeleteSuccessful]);
  const handleShowVendorResponseEditor = () => {
    setShowEditor(!showEditor);
  };
  const handleDeleteReview = (e, endpoint) => {
    runDelete("".concat(mpacBaseUrl).concat(endpoint));
  };
  const handleDeletedVendorResponse = () => {
    setpostedVendorResponse('');
    filterOutDeletedVendorResponse(index);
  };
  const preloadVendorResponseEditor = () => {
    LazyVendorResponseEditor.preload();
  };
  const response = postedVendorResponse || vendorDetails.response;
  return /*#__PURE__*/React.createElement(UserReviewContainer, {
    "data-testid": TEST_ID.REVIEWS_TAB_USER_REVIEW
  }, /*#__PURE__*/React.createElement(AvatarContainer, null, /*#__PURE__*/React.createElement(Avatar, {
    appearance: "circle",
    src: picture,
    size: "large"
  })), /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(Ratings, {
    showRatingCount: false,
    ratings: ratings
  }), /*#__PURE__*/React.createElement(ReviewHeading, null, "by ", /*#__PURE__*/React.createElement(Author, {
    href: profileUrl
  }, name), " on ", date), /*#__PURE__*/React.createElement(ReviewContent, null, review), /*#__PURE__*/React.createElement(UserActions, null, /*#__PURE__*/React.createElement(VoteReview, {
    mpacBaseUrl: mpacBaseUrl,
    voteUpEndpoint: voteUpEndpoint,
    voteDownEndpoint: voteDownEndpoint,
    totalVotes: totalVotes,
    helpfulVotes: helpfulVotes,
    isLoggedIn: user.isLoggedIn,
    loginHref: loginHref
  }), /*#__PURE__*/React.createElement(ActionContainer, null, selfEndpoint && (user.isMpacAdmin || isReviewAuthor) ? /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "link",
    isLoading: isDeletingInProgress,
    spacing: "none",
    onClick: e => handleDeleteReview(e, selfEndpoint),
    "aria-label": "Delete User Review",
    testId: TEST_ID.REVIEWS_TAB_DELETE_REVIEW
  }, "Delete") : null, !response && permissions && /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    onClick: handleShowVendorResponseEditor,
    onMouseEnter: preloadVendorResponseEditor,
    spacing: "none",
    testId: TEST_ID.REVIEWS_TAB_RESPOND_REVIEW
  }, "Respond"), flagEndpoint ? /*#__PURE__*/React.createElement(FlagReview, {
    mpacBaseUrl: mpacBaseUrl,
    flagEndpoint: flagEndpoint
  }) : null)), showEditor && /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement("div", null)
  }, /*#__PURE__*/React.createElement(LazyVendorResponseEditor, {
    closeVendorResponseEditor: handleShowVendorResponseEditor,
    vendorResponseEndpoint: vendorDetails.responseEndpoint,
    onVendorResponseSubmit: handlePostedVendorResponse,
    response: response,
    reviewId: id
  })), !showEditor && response ? /*#__PURE__*/React.createElement(VendorResponse, {
    name: vendorDetails.name,
    logo: vendorDetails.logo,
    response: response,
    vendorResponseEndpoint: vendorDetails.responseEndpoint,
    mpacBaseUrl: mpacBaseUrl,
    onEditVendorResponse: handleEditVendorResponse,
    permissions: permissions,
    preloadVendorResponseEditor: preloadVendorResponseEditor,
    handleDeletedVendorResponse: handleDeletedVendorResponse
  }) : null));
};